import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  ApiPostLegalBase,
  ApiGetNCMList,
  ApiGetNCMInfo,
  ApiPostTaxInformationUniao,
  ApiPostTaxInformationSP,
  ApiGetTaxInformationSP,
  ApiGetTaxInformationUniao,
  ApiPostChatGptUniaoQuestion,
  ApiPostChatGptUniaoResponse,
  ApiPostChatGptSPQuestion,
  ApiPostChatGptSPResponse
} from './baseLegal.api';

export const postLegalBase = createAsyncThunk(
  'api/postlegalbase',
  async ({
    initial_date,
    final_date,
    cnpj,
    nat_oper,
    market,
    estab_rem,
    tributation
  }) => {
    let response = await ApiPostLegalBase({
      initial_date,
      final_date,
      cnpj,
      nat_oper,
      market,
      estab_rem,
      tributation
    });
    return response;
  }
);

export const getNCMList = createAsyncThunk('api/basencmlist', async () => {
  let response = await ApiGetNCMList();
  return response;
});

export const getNCMInfo = createAsyncThunk(
  'api/basencminfo',
  async ({ cnpj, ncm }) => {
    let response = await ApiGetNCMInfo({
      cnpj,
      ncm
    });
    return response;
  }
);

// Tax Information Page
export const getTaxInformationSP = createAsyncThunk(
  'api/taxinformationsp',
  async () => {
    let response = await ApiGetTaxInformationSP();
    return response;
  }
);

export const getTaxInformationUniao = createAsyncThunk(
  'api/taxinformationuniao',
  async () => {
    let response = await ApiGetTaxInformationUniao();
    return response;
  }
);

export const postTaxInformationUniao = createAsyncThunk(
  'api/postTaxInformation',
  async ({
    days,
    organizacao,
    organizacao_subordinada,
    tipoato,
    page_size,
    page
  }) => {
    let response = await ApiPostTaxInformationUniao({
      days,
      organizacao,
      organizacao_subordinada,
      tipoato,
      page_size,
      page
    });
    return response;
  }
);

export const postTaxInformationSP = createAsyncThunk(
  'api/postTaxInformationSP',
  async ({ days, caderno, secao, page_size, page }) => {
    let response = await ApiPostTaxInformationSP({
      days,
      caderno,
      secao,
      page_size,
      page
    });
    return response;
  }
);

export const postChatGptUniaoQuestion = createAsyncThunk(
  'api/postChatGptUniaoQuestion',
  async ({
    pergunta,
    diario_oficial,
    days,
    organizacao,
    organizacao_subordinada,
    tipoato,
    page_size,
    page
  }) => {
    let response = await ApiPostChatGptUniaoQuestion({
      pergunta,
      diario_oficial,
      days,
      organizacao,
      organizacao_subordinada,
      tipoato,
      page_size,
      page
    });
    return response;
  }
);

export const postChatGptUniaoResponse = createAsyncThunk(
  'api/postChatGptUniaoResponse',
  async ({
    pergunta,
    diario_oficial,
    days,
    organizacao,
    organizacao_subordinada,
    tipoato,
    page_size,
    page
  }) => {
    let response = await ApiPostChatGptUniaoResponse({
      pergunta,
      diario_oficial,
      days,
      organizacao,
      organizacao_subordinada,
      tipoato,
      page_size,
      page
    });
    return response;
  }
);

export const postChatGptSPQuestion = createAsyncThunk(
  'api/postChatGptSPQuestion',
  async ({
    pergunta,
    diario_oficial,
    days,
    caderno,
    secao,
    page_size,
    page
  }) => {
    let response = await ApiPostChatGptSPQuestion({
      pergunta,
      diario_oficial,
      days,
      caderno,
      secao,
      page_size,
      page
    });
    return response;
  }
);

export const postChatGptSPResponse = createAsyncThunk(
  'api/postChatGptSPResponse',
  async ({
    pergunta,
    diario_oficial,
    days,
    caderno,
    secao,
    page_size,
    page
  }) => {
    let response = await ApiPostChatGptSPResponse({
      pergunta,
      diario_oficial,
      days,
      caderno,
      secao,
      page_size,
      page
    });
    return response;
  }
);

//export const notaAvulsaDataSlice
//name: 'notaavulsa'
//export const notaAvulsaSelector = (state) => state.notaAvulsaData
export const legalBaseDataSlice = createSlice({
  name: 'legalbase',
  initialState: {
    isPostLegalBase: false,
    legalBaseBody: {},
    isLoadingNCMList: false,
    ncmList: {},
    isLoadingNCMInfo: false,
    ncmInfo: {},
    isPostTaxInformation: false,
    taxInformationBody: {},
    isPostTaxInformationSP: false,
    taxInformationBodySP: {},
    isLoadingTaxInformationSP: false,
    taxInformationSP: {},
    isLoadingTaxInformationUniao: false,
    taxInformationUniao: {},
    isPostChatGptUniaoQuestion: false,
    chatGptUniaoQuestion: {},
    isPostChatGptUniaoResponse: false,
    chatGptUniaoResponse: {},
    isPostChatGptSPQuestion: false,
    chatGptSPQuestion: {},
    isPostChatGptSPResponse: false,
    chatGptSPResponse: {}
  },
  reducers: {},
  extraReducers: {
    [postLegalBase.pending]: (state) => {
      state.isPostLegalBase = 'loading';
    },
    [postLegalBase.fulfilled]: (state, action) => {
      state.isPostLegalBase = 'success';
      state.legalBaseBody = action.payload;
    },
    [postLegalBase.rejected]: (state) => {
      state.isPostLegalBase = 'failed';
    },
    [getNCMList.pending]: (state) => {
      state.isLoadingNCMList = 'loading';
    },
    [getNCMList.fulfilled]: (state, action) => {
      state.isLoadingNCMList = 'success';
      state.ncmList = action.payload;
    },
    [getNCMList.rejected]: (state) => {
      state.isLoadingNCMList = 'failed';
    },
    [getNCMInfo.pending]: (state) => {
      state.isLoadingNCMInfo = 'loading';
    },
    [getNCMInfo.fulfilled]: (state, action) => {
      state.isLoadingNCMInfo = 'success';
      state.ncmInfo = action.payload;
    },
    [getNCMInfo.rejected]: (state) => {
      state.isLoadingNCMInfo = 'failed';
    },
    [getTaxInformationSP.pending]: (state) => {
      state.isLoadingTaxInformationSP = 'loading';
    },
    [getTaxInformationSP.fulfilled]: (state, action) => {
      state.isLoadingTaxInformationSP = 'success';
      state.taxInformationSP = action.payload;
    },
    [getTaxInformationSP.rejected]: (state) => {
      state.isLoadingTaxInformationSP = 'failed';
    },
    [getTaxInformationUniao.pending]: (state) => {
      state.isLoadingTaxInformationUniao = 'loading';
    },
    [getTaxInformationUniao.fulfilled]: (state, action) => {
      state.isLoadingTaxInformationUniao = 'success';
      state.taxInformationUniao = action.payload;
    },
    [getTaxInformationUniao.rejected]: (state) => {
      state.isLoadingTaxInformationUniao = 'failed';
    },
    [postTaxInformationUniao.pending]: (state) => {
      state.isPostTaxInformation = 'loading';
    },
    [postTaxInformationUniao.fulfilled]: (state, action) => {
      state.isPostTaxInformation = 'success';
      state.taxInformationBody = action.payload;
    },
    [postTaxInformationUniao.rejected]: (state) => {
      state.isPostTaxInformation = 'failed';
    },
    [postTaxInformationSP.pending]: (state) => {
      state.isPostTaxInformationSP = 'loading';
    },
    [postTaxInformationSP.fulfilled]: (state, action) => {
      state.isPostTaxInformationSP = 'success';
      state.taxInformationBodySP = action.payload;
    },
    [postTaxInformationSP.rejected]: (state) => {
      state.isPostTaxInformationSP = 'failed';
    },
    [postChatGptUniaoQuestion.pending]: (state) => {
      state.isPostChatGptUniaoQuestion = 'loading';
    },
    [postChatGptUniaoQuestion.fulfilled]: (state, action) => {
      state.isPostChatGptUniaoQuestion = 'success';
      state.chatGptUniaoQuestion = action.payload;
    },
    [postChatGptUniaoQuestion.rejected]: (state) => {
      state.isPostChatGptUniaoQuestion = 'failed';
    },
    [postChatGptUniaoResponse.pending]: (state) => {
      state.isPostChatGptUniaoResponse = 'loading';
    },
    [postChatGptUniaoResponse.fulfilled]: (state, action) => {
      state.isPostChatGptUniaoResponse = 'success';
      state.chatGptUniaoResponse = action.payload;
    },
    [postChatGptUniaoResponse.rejected]: (state) => {
      state.isPostChatGptUniaoResponse = 'failed';
    },
    [postChatGptSPQuestion.pending]: (state) => {
      state.isPostChatGptSPQuestion = 'loading';
    },
    [postChatGptSPQuestion.fulfilled]: (state, action) => {
      state.isPostChatGptSPQuestion = 'success';
      state.chatGptSPQuestion = action.payload;
    },
    [postChatGptSPQuestion.rejected]: (state) => {
      state.isPostChatGptSPQuestion = 'failed';
    },
    [postChatGptSPResponse.pending]: (state) => {
      state.isPostChatGptSPResponse = 'loading';
    },
    [postChatGptSPResponse.fulfilled]: (state, action) => {
      state.isPostChatGptSPResponse = 'success';
      state.chatGptSPResponse = action.payload;
    },
    [postChatGptSPResponse.rejected]: (state) => {
      state.isPostChatGptSPResponse = 'failed';
    }
  }
});

export const legalBaseSelector = (state) => state.legalBaseData;

export default legalBaseDataSlice.reducer;
